import { render } from "./Sidebar.vue?vue&type=template&id=469222b3&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=469222b3&lang=scss&scoped=true"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469222b3"]])

export default __exports__